var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227.51,
    height: 218.913,
    viewBox: "0 0 227.51 218.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1007d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(-1098.7 -349.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M350.788,481.655c.381,11.97-15.991,21.567-19.268,32.383-3.407,11.249,4.729,28.3-1.969,37.633-6.771,9.433-25.588,7.175-35.021,13.947-9.331,6.7-13.2,25.281-24.449,28.689-10.815,3.277-24.308-9.9-36.278-10.28-10.92-.347-24.174,12.3-34.047,8.849-10.16-3.553-12.651-21.812-21.163-28.111-8.578-6.347-26.739-3.387-33.086-11.964-6.3-8.511,1.837-24.968-1.716-35.128-3.451-9.873-20.151-17.661-20.5-28.58-.381-11.971,15.991-21.567,19.268-32.383,3.407-11.249-4.729-28.3,1.969-37.633,6.771-9.433,25.588-7.175,35.02-13.947,9.331-6.7,13.2-25.282,24.448-28.689,10.816-3.277,24.31,9.9,36.28,10.28,10.919.347,24.174-12.3,34.047-8.849,10.16,3.551,12.649,21.811,21.163,28.11,8.576,6.346,26.739,3.387,33.086,11.964,6.3,8.514-1.837,24.969,1.716,35.13C333.738,462.947,350.438,470.734,350.788,481.655Z",
    transform: "translate(975.416 -26.468)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M275.322,467.635c-16.177-13.027-36.642-19.889-57.384-20.742v-7.067a16.817,16.817,0,1,0-21.187-16.24,4.366,4.366,0,0,0,8.733,0,8.084,8.084,0,1,1,8.088,8.084,4.366,4.366,0,0,0-4.367,4.365v10.857c-20.744.853-41.207,7.713-57.384,20.744a8.732,8.732,0,0,0,10.953,13.6c28.013-22.554,73.587-22.554,101.591,0a8.733,8.733,0,0,0,10.957-13.6Z",
    transform: "translate(997.003 2.753)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/Badge.f280a838b55a40445f8ff03c0e02a832.svg";
export { ForwardRef as ReactComponent };